import { FormControl, Grid, TextField, Typography } from '@mui/material';
import PrimaryButton from '../common/styled-mui-overrides/PrimaryButton';
import { useState } from 'react';
import { ProcureVendorContactInput } from '../../types/vendors';

type ProcureVendorContactFormProps = {
  onSubmit: (contact: ProcureVendorContactInput) => void;
  buttonText: string;
  vendorContactInput?: ProcureVendorContactInput;
};

export default function ProcureVendorContactForm(props: ProcureVendorContactFormProps) {
  const [formInput, setFormInput] = useState<ProcureVendorContactInput>({
    fullName: props.vendorContactInput?.fullName || '',
    role: props.vendorContactInput?.role || '',
    phone: props.vendorContactInput?.phone || '',
    email: props.vendorContactInput?.email || '',
    notes: props.vendorContactInput?.notes || '',
  });

  return (
    <Grid container spacing={2} paddingY={2}>
      <Grid item xs={12}>
        <FormControl fullWidth>
          <TextField
            required
            size={'small'}
            label={'Full name'}
            variant='outlined'
            value={formInput.fullName}
            onChange={e => {
              setFormInput({ ...formInput, fullName: e.target.value });
            }}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <FormControl fullWidth>
          <TextField
            size={'small'}
            label={'Role'}
            variant='outlined'
            value={formInput.role}
            onChange={e => {
              setFormInput({ ...formInput, role: e.target.value });
            }}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <FormControl fullWidth>
          <TextField
            size={'small'}
            label={'Phone number'}
            variant='outlined'
            value={formInput.phone}
            onChange={e => {
              setFormInput({ ...formInput, phone: e.target.value });
            }}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <FormControl fullWidth>
          <TextField
            size={'small'}
            label={'Email'}
            variant='outlined'
            value={formInput.email}
            onChange={e => {
              setFormInput({ ...formInput, email: e.target.value });
            }}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <FormControl fullWidth>
          <TextField
            size={'small'}
            label={'Notes'}
            variant='outlined'
            multiline
            rows={4}
            value={formInput.notes}
            onChange={e => {
              setFormInput({ ...formInput, notes: e.target.value });
            }}
          />
        </FormControl>
      </Grid>
      <Grid item>
        <PrimaryButton onClick={() => props.onSubmit(formInput)}>{props.buttonText}</PrimaryButton>
      </Grid>
    </Grid>
  );
}
